const webpackContext = require.context('./modules/', true, /\.js$/);
const appRoutes = [];

webpackContext.keys().map((item) => {
  const defaultModule = webpackContext(item).default;
  if (!defaultModule) return;
  const moduleList = Array.isArray(defaultModule)
    ? [...defaultModule]
    : [defaultModule];
  appRoutes.push(...moduleList);
});

export default appRoutes;
